

import {  useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';

import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import apiService from "../api/ApiService";
import { loginSuccessCollectors } from "../redux/slices/collectorsSlice";
import { Close, Code, Details, LocationCity, LocationOn, ModelTraining } from "@mui/icons-material";

const moment=require('moment-jalaali');


const NewPacket=({penr})=>{
    const {currentAdmin}=useSelector(state=>state.p.admin)
    const {currentCollectors}=useSelector(state=>state.collectors)
    const {openModalls,isOpenModal,closeModalls}=useGlobalContext();
    const dispatch=useDispatch();
    const {
        register,
        handleSubmit,
        formState: { errors }
      } = useForm();
   

    const updatePen=async(data)=>{           

                    const data1=JSON.stringify({...data,farmId:currentAdmin.id})
                    const res=await apiService.addNewCollector(data1)
                    
                    dispatch(loginSuccessCollectors([...currentCollectors,res.data]))
                openModalls()
  
    }
    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={handleSubmit(updatePen)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <AddToPhotosIcon fontSize="large"/>

            <h4 >  ایجاد کالکتور</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("deviceCode",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Code fontSize='small'/> کد کالکتور</label>
            {errors?.deviceCode?.message&&<span className='errMsg'>{errors.deviceCode.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("specs",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Details fontSize="small"/> مشخصات کالکتور</label>
            {errors?.specs?.message&&<span className='errMsg'>{errors.specs.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("installedLocation",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><LocationOn fontSize='small'/>  محل نصب</label>
            {errors?.installedLocation?.message&&<span className='errMsg'>{errors.installedLocation.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("version",{required:'این مقدار ضروری است',pattern:{
                value:/^.{1,50}$/,
                message:'    حداکثر 50 کاراکتر'
            }})}/>
            <label for="" className={'labelSS'}><ModelTraining fontSize="small"/> ورژن   </label>
            {errors?.version?.message&&<span className='errMsg'>{errors.version.message}</span>}
        </div>
        <button className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'220px'}}> 
        
        </div>
        
    </div>
}
export default NewPacket